import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { useListarImpostos } from "core/features/Imposto/hooks/useListarImpostos";
import { ImpostoDto } from "core/features/Imposto/typings/index";
import { useState } from "react";
import ModalCadastrarImposto from "./../../../pages/Admin/Financeiro/Impostos/Listagem/components/ListarImpostos/ModalCadastrarImposto/index";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { useDebounce } from "core/features/shared/useDebouce";

export interface SelectImpostosProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
}

function SelectImpostos({
  value,
  isInvalid,

  ...rest
}: SelectImpostosProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  const debouncedSearch = useDebounce(search);

  const { data, isLoading, refetch, isFetching } = useListarImpostos({
    search: debouncedSearch,
  });

  const options = data?.items.map((item: ImpostoDto) => ({
    value: item.id,
    label: item.nome,
    ...item,
  }));

  const _isLoading = isLoading || isFetching;
  return (
    <>
      {isOpenModal ? (
        <ModalCadastrarImposto
          onClose={() => setIsOpenModal(false)}
          open={isOpenModal}
          refetchList={refetch}
        />
      ) : null}
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        loading={_isLoading}
        searchValue={search}
        onSearch={setSearch}
        filterOption={false}
        showSearch
        getPopupContainer={(node) => node.parentNode}
        placeholder="Tipo de recorrência"
        style={{ width: "100%" }}
        value={value}
        options={options}
        {...rest}
        notFoundContent={
          !_isLoading ? (
            <Box>
              Nenhum imposto encontrado
              <Button
                isLoading={isLoading}
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar novo
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      ></SelectBaseAntd>
    </>
  );
}

export default SelectImpostos;
